import axios from "axios";
import authHeader from '../../../authheader'

const PLSAPPLICATIONURL = process.env.REACT_APP_APIURL + "/api/IndividualPlsReinstatement";

const getPersonalReferences = (reinstatementId) => {
    return axios.get(`${PLSAPPLICATIONURL}/personalreferences`, { headers: authHeader(), params: { reinstatementId } });
}
const postPersonalReference = (data) => {
    return axios.post(`${PLSAPPLICATIONURL}/personalreference`, data, { headers: authHeader() });
}
const sendPersonalReferenceEmail = (referenceId) => {
    return axios.post(`${PLSAPPLICATIONURL}/sendreferenceemail`, null, { headers: authHeader(), params: { referenceId } });
}
export default {
    getPersonalReferences,
    postPersonalReference,
    sendPersonalReferenceEmail
}